import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { DepartmentOption, DepartmentPl } from '../interfaces/costCentre.interface';
import { saveBlob } from '../utils/saveBlob';
import { parseContentDispositionFilename } from '../utils/contentDisposition';

const institution = () => AuthService.getSelectedInstitution()!;

export interface DepartmentPlParams {
    from: string;
    to: string;
    departmentId?: string;
}

export const CostCentreService = {
    /** Live departments for a picker (any institution member may read). */
    getDepartments: async (): Promise<DepartmentOption[]> =>
        (await axios.get(ENDPOINTS.COST_CENTRE.DEPARTMENTS(institution()))).data,

    getDepartmentPl: async (p: DepartmentPlParams): Promise<DepartmentPl> =>
        (await axios.get(ENDPOINTS.COST_CENTRE.DEPARTMENT_PL(institution()), { params: p })).data,

    /** Downloads exactly the filters passed in (callers pass the APPLIED ones, not the draft form values). */
    downloadDepartmentPl: async (p: DepartmentPlParams, format: 'pdf' | 'xlsx' = 'xlsx'): Promise<void> => {
        const response = await axios.get(ENDPOINTS.COST_CENTRE.DEPARTMENT_PL_EXPORT(institution()), {
            params: { ...p, format },
            responseType: 'blob',
        });
        const disposition: string = response.headers?.['content-disposition'] ?? '';
        saveBlob(new Blob([response.data]), parseContentDispositionFilename(disposition, `department-pl-${p.to}.${format}`));
    },
};
